import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const newsCategoryApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/newsCategory",
      params,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/newsCategory",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/newsCategory/${id}`,
      method: "patch",
      data,
    }),
  upload: (data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/newsCategory/upload`,
      method: "post",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/newsCategory/${id}`,
      method: "delete",
    }),
};
